﻿import { RegularShape } from 'ol/style';
import { asColorLike } from 'ol/colorlike';

export default class ArrowRightStyle extends RegularShape {
    constructor(options = {}) {
        super(options);
        this._openRatio = options.openRatio ?? 0.28;     // fraction for how open the ">" is
        this._marginRatio = options.marginRatio ?? 0.14; // fraction of size for padding
    }

    draw_(renderOptions, context, pixelRatio) {
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        context.beginPath();

        const strokeW = renderOptions.strokeWidth || 1;

        // Full canvas size (from OL) and the drawable square we use (we keep
        // the -1 like your CrossStyle to avoid edge bleeding)
        const fullSize = renderOptions.size;
        const symbolSize = Math.max(0, fullSize - 1 - 2 * strokeW);

        // Center the drawable square inside the full canvas so stroke width changes
        // don't shift the visual center.
        const pad = Math.round((fullSize - symbolSize) / 2);
        context.translate(pad, pad);

        // Geometry params
        const mRatio = this._marginRatio ?? 0.14;
        const openRatio = Math.max(0, Math.min(0.49, this._openRatio ?? 0.28));

        const m = Math.round(symbolSize * mRatio);
        const w = symbolSize;
        const h = symbolSize;
        const half = symbolSize / 2;

        // Compute left and tip x so the chevron is visually centered.
        // Center is at half; we place the tip to the right and base to the left symmetric around half.
        const innerWidth = w - 2 * m;
        const tipX = half + innerWidth * 0.5 * (1 - openRatio); // nearer to right edge
        const leftX = 2 * half - tipX;                           // symmetric around center

        const yTop = m;
        const yMid = half;
        const yBot = h - m;

        context.moveTo(leftX, yTop);
        context.lineTo(tipX, yMid);
        context.lineTo(leftX, yBot);

        // Stroke/fill same as your CrossStyle
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = strokeW;
            if (context.setLineDash && renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap || 'round';
            context.lineJoin = renderOptions.lineJoin || 'round';
            context.miterLimit = renderOptions.miterLimit ?? 2;
            context.stroke();
        } else if (this.fill_) {
            let color = this.fill_.getColor();
            context.strokeStyle = asColorLike(color ?? '#000');
            context.lineWidth = Math.max(1, strokeW);
            context.stroke();
        }

        context.closePath();
    }
}